import { Box, Button, Stack, Typography } from '@mui/material'
import { CARD_SX } from '../../agent'
import type { UiCallView } from './uiCalls'

/**
 * The page changes a message made through ui_call (#1534): one caption each,
 * and Confirm / Cancel on a change that waits for the user's click.
 */
export default function UiCallCaptions({ views, onConfirm, onCancel }: {
  views: UiCallView[]
  onConfirm?: (callId: string) => void
  onCancel?: (callId: string) => void
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: '100%' }}>
      {views.map(view => (
        <Box key={view.id} sx={{ ...CARD_SX, p: 1.25 }} data-ui-call={view.tool} data-ui-call-status={view.status}>
          <Typography variant="caption" color={view.status === 'failed' ? 'error' : 'text.secondary'} sx={{ display: 'block' }}>
            {view.caption}
          </Typography>
          {(view.status === 'needs_confirmation' || view.status === 'confirming') && (
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              <Button
                size="small"
                variant="contained"
                color="info"
                disabled={view.status === 'confirming'}
                onClick={() => onConfirm?.(view.id)}
              >
                {view.confirmLabel || 'Confirm'}
              </Button>
              <Button
                size="small"
                color="info"
                disabled={view.status === 'confirming'}
                onClick={() => onCancel?.(view.id)}
              >
                Cancel
              </Button>
            </Stack>
          )}
        </Box>
      ))}
    </Box>
  )
}
